// extracted by mini-css-extract-plugin
module.exports = {"purchaseReview":"affiliateContext_purchaseReview__3-lwm","addressBlock":"affiliateContext_addressBlock__XXXkh","idBlock":"affiliateContext_idBlock__DbGsJ"};